<div class="esf-form-item"
     app-form-field-search
     [placeholder]="i18nPlaceholder"
     [id]="'filterClubAssignment'"
     (inputChanged)="filterTable($event.target.value)">
</div>
<table class="esf-table"
       app-table
       [selectableTable]="true"
       [columns]="columns"
       [keys]="keys"
       [data]="filteredTableData"
       (rowClickEvent)="setSelected($event)">
</table>
